export default "__VITE_ASSET__DC1F80GE__"